// Console types

export const LOAD_ORDERS_TO_STATE = 'LOAD_ORDERS_TO_STATE'
export const SET_TRACKING = 'SET_TRACKING'
export const SET_RETAILPRO = 'SET_RETAILPRO'
export const SET_STATUS = 'SET_STATUS'
export const TOGGLE_ORDER_PAUSE = 'TOGGLE_ORDER_PAUSE'
